<template>
    <div class="fixed inset-0 z-50">
        <div class="absolute inset-0 bg-echoes-background-black/80 backdrop-blur-sm"></div>
        <navbar v-if="showNavbar" class="relative z-10" />
        <div class="relative z-10 min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
            <div class="bg-echoes-background-gray rounded-[21px] border border-echoes-border-gray max-w-xl p-8">
                <div class="text-center">
                    <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full">
                        <svg class="h-12 w-12 text-green-600 dark:text-green-300" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                        </svg>
                    </div>
                    
                    <h2 class="mt-6 text-3xl font-extrabold text-echoes-background-black dark:text-white">
                        {{ title }}
                    </h2>
                    
                    <p class="mt-2 text-echoes-background-gray dark:text-gray-300">
                        {{ message }}
                        <span v-if="showCountdown">{{ countdown }} seconds...</span>
                    </p>

                    <div class="mt-8 flex justify-center space-x-4">
                        <button 
                            @click="handleAction" 
                            class="transition-all duration-200 ease-in-out inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-[13px] text-white bg-echoes-primary hover:bg-echoes-primary/80 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-echoes-primary"
                        >
                            {{ buttonText }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, defineProps } from 'vue';
import { useRouter } from 'vue-router';
import { useLayoutComponents } from '@/composables/layout.js';
const { Navbar } = useLayoutComponents();

const props = defineProps({
    showNavbar: {
        type: Boolean,
        default: true
    },
    title: {
        type: String,
        default: 'RFP Response Submitted!'
    },
    message: {
        type: String,
        default: 'The RFP issuer will review your submission and contact you soon.'
    },
    buttonText: {
        type: String,
        default: 'Back to Explore'
    },
    redirectPath: {
        type: String,
        default: '/explore'
    },
    showCountdown: {
        type: Boolean,
        default: false
    },
    countdownDuration: {
        type: Number,
        default: 5
    }
});

const router = useRouter();
const countdown = ref(props.countdownDuration);
let timer;

const handleAction = () => {
    router.push(props.redirectPath);
};

onMounted(() => {
    if (props.showCountdown) {
        timer = setInterval(() => {
            countdown.value--;
            if (countdown.value <= 0) {
                handleAction();
            }
        }, 1000);
    }
});

onUnmounted(() => {
    if (timer) {
        clearInterval(timer);
    }
});
</script> 